var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeemSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1196"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "All mutualfunds"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": 868540
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1475"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1474"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3345",
    d: "M35.421 6H10.633A5.64 5.64 0 005 11.633v.067a5.64 5.64 0 005.633 5.633h.07v19.088a5.64 5.64 0 005.633 5.633h13.45a5.64 5.64 0 005.633-5.633 1.409 1.409 0 00-2.817 0 2.82 2.82 0 01-2.817 2.817H16.337a2.82 2.82 0 01-2.817-2.817V8.817H32.6v20.562a1.409 1.409 0 002.817 0V17.337a5.64 5.64 0 005.637-5.637v-.07A5.64 5.64 0 0035.421 6zM10.7 14.524h-.07A2.82 2.82 0 017.817 11.7v-.07a2.82 2.82 0 012.816-2.813h.067zM38.237 11.7a2.82 2.82 0 01-2.817 2.817v-5.7a2.82 2.82 0 012.817 2.817z",
    fill: "#6d6e71"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1477"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1476"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3346",
    d: "M23.036 17.619a6.426 6.426 0 106.9 6.408 6.676 6.676 0 00-6.9-6.408zm0 10a3.621 3.621 0 114.084-3.591 3.866 3.866 0 01-4.084 3.591z",
    fill: "#97144d"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1479"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1478"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 171",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(21 34)",
    fill: "#97144d"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1481"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1480"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 172",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(21 12)",
    fill: "#97144d"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 131",
    fill: "#97144d",
    stroke: "#f6f7f8",
    strokeWidth: 2,
    transform: "translate(32 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon / Done / Black",
    d: "M41.739 17.087l-2.792-2.792-.947.947 3.739 3.739 8.034-8.034-.947-.947z",
    fill: "#fff"
  }))));
}
export default SvgRedeemSuccess;